import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CardSet from '@/components/CardSet.vue';
import Loading from '@/components/Loading.vue';
import BackButton from '@/components/BackButton.vue';
const deploymentsModule = namespace('deployments');
let StarshipsDeployments = class StarshipsDeployments extends Vue {
    created() {
        this.fetchDeployments();
    }
    get deploymentsWithLinks() {
        return this.deployments.map(deployment => ({
            ...deployment,
            to: `deployments/${deployment.name}`
        }));
    }
};
__decorate([
    deploymentsModule.State
], StarshipsDeployments.prototype, "deployments", void 0);
__decorate([
    deploymentsModule.Action
], StarshipsDeployments.prototype, "fetchDeployments", void 0);
StarshipsDeployments = __decorate([
    Component({
        components: {
            Loading,
            BackButton,
            CardSet
        }
    })
], StarshipsDeployments);
export default StarshipsDeployments;
